import { render, staticRenderFns } from "./TemplateApp.vue?vue&type=template&id=0b55946c&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./TemplateApp.vue?vue&type=script&lang=js&"
export * from "./TemplateApp.vue?vue&type=script&lang=js&"
import style0 from "./TemplateApp.vue?vue&type=style&index=0&id=0b55946c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VBtn,VContent})
